export default "__VITE_ASSET__C9LrQmPw__"